"use client";

import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, Slide } from "react-toastify";

interface ToastProviderProps {
  children: React.ReactNode;
}

export default function ToastProvider({ children }: ToastProviderProps) {
  return (
    <>
      {children}
      <ToastContainer
        toastClassName={"!p-0"}
        // toastClassName={(context) => contextClass[context?.type || "default"] + " relative flex rounded-md px-6 py-3 justify-between overflow-hidden cursor-pointer"}
        position="top-right"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick={true}
        limit={1}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={true}
        pauseOnHover={true}
        theme="colored"
        // Smooth transitions
        transition={Slide}
        // Custom styling for smooth animations
        style={{
          zIndex: 9999,
        }}
        // Enhanced animation timing
        closeButton={false}
        icon={false}
      />
    </>
  );
}
